import { useState, useEffect } from 'react';
import Timer from '../components/Timer';
import PreviousSvg from '../../../svg/student/Previous.js';
import NextSvg from '../../../svg/student/Next.js';
import ReloadSvg from '../../../svg/student/Reload.js';

const mission = {
    time: 40 // 40 minutes
}
export default function Mission4(props) {
    const isMobile = window.innerWidth <= 1024
    // const [remainingTime, setremainingTime] = useState(40 * 60); //40 mins
    // const [startTime, setStartTime] = useState(new Date());
    // const getRemainingTimeString = () => {
    //     if ((!remainingTime) || remainingTime <= 0) return '00:00'
    //     let time = remainingTime
    //     let hours = Math.floor(time / 3600);
    //     let minutes = Math.floor((time - (hours * 3600)) / 60);
    //     let seconds = Math.floor(time - (hours * 3600) - (minutes * 60));
    //     //return `${hours < 10 ? `0` : ''}${hours}:${minutes < 10 ? `0` : ''}${minutes}:${seconds < 10 ? `0` : ''}${seconds}`
    //     return `${minutes < 10 ? `0` : ''}${minutes}:${seconds < 10 ? `0` : ''}${seconds}`
    // }
    // useEffect(() => {
    //     let timeInterval = null
    //     timeInterval = setInterval(() => {
    //         let second = (startTime.getTime() + mission.time * 60 * 1000 - Date.now()) / 1000
    //         setremainingTime(second <= 0 ? 0 : second)
    //     }
    //         , 1000)
    //     return () => { clearInterval(timeInterval) }
    // }, [startTime])


    const [question1TabIndex, setQuestion1TabIndex] = useState(0);
    const [question1SelectedAnswers, setQuestion1SelectedAnswers] = useState([]);
    const [question1PopupVisible, setQuestion1PopupVisible] = useState(false);

    const [question2TabIndex, setQuestion2TabIndex] = useState(0);
    const [question2SelectedAnswers, setQuestion2SelectedAnswers] = useState([]);
    const [question2PopupVisible, setQuestion2PopupVisible] = useState(false);

     const [showWrongAnswerPopup1, setShowWrongAnswerPopup1] = useState(false);
     const [showWrongAnswerPopup2, setShowWrongAnswerPopup2] = useState(false);

    return (
        <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex text-[black]' style={{ overflowY: "auto", fontSize: isMobile ? 12 : '1.5rem' }}>
            {/*header*/}
            <div className='w-full flex flex-row justify-between items-center bg-[black]' style={{ gap: isMobile ? '4px' : '16px', overflow: 'auto', paddingLeft: isMobile ? 8 : 24, paddingRight: isMobile ? 8 : 24, height: isMobile ? 50 : 65 }}>
                {/* <Timer text={getRemainingTimeString()} percentage={(1 - ((remainingTime || 0) / ((mission.time * 60) || 1))) * 100} /> */}
            </div>
            {/*end of header*/}

            {/*content*/}
            <div className='flex flex-row w-full flex-1 bg-[#D9D9D9]' style={{ overflow: 'hidden' }}>
                {/*webpages*/}
                <div className='flex flex-col w-full bg-[white]' style={{ border: isMobile ? '2px solid black' : '2px solid black', padding: isMobile ? 4 : 10 }}>

                    <div className='w-full flex flex-row bg-[white] items-center' style={{ border: isMobile ? '2px solid black' : '2px solid black', marginTop: 4, marginBottom: 4, gap: isMobile ? 2 : 6, padding: isMobile ? 2 : 6 }}>
                        <div className='cursor-pointer'>
                            <PreviousSvg height={isMobile ? 18 : 30} width={isMobile ? 18 : 30} />
                        </div>
                        <div className='cursor-pointer'>
                            <NextSvg height={isMobile ? 18 : 30} width={isMobile ? 18 : 30} />
                        </div>
                        <div className='cursor-pointer'>
                            <ReloadSvg height={isMobile ? 18 : 30} width={isMobile ? 18 : 30} />
                        </div>
                        <div className='flex-1'>
                            <input disabled={true} className='w-full text-[black] bg-[#EEF2F6] rounded-[4px]' value={'https://reading-practice.com'} style={{ fontSize: isMobile ? 10 : 16, height: isMobile ? 26 : 40, paddingLeft: isMobile ? 12 : 24, paddingRight: isMobile ? 12 : 24 }} />
                        </div>
                    </div>
                    {/*end tabs*/}

                    {/*web content*/}
                    <div className='flex w-full flex-1 bg-[white] flex-col justify-start' style={{ overflowY: 'auto', border: '2px solid black' }}>
                        <img src='/閱讀策略/2-01.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />

                        <div className='w-full bg-[white] flex flex-col justify-start p-[32px] items-center'>
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>
                                線上閱讀跟紙本閱讀最大的不同，在於我們需要「先預測、後點擊」。這就像在猜謎一樣：你要的答案，會在這裏面嗎？網頁上的超連結(藍色字或按鈕)就像路牌，點擊前，先讀一讀那幾個字，想想它背後代表甚麼主題。
                            </div>
                            <br />
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>
                                怎麼學？兩步教你「超前預測」：
                            </div>

                        </div>
                        <img src='/閱讀策略/task2-00.jpg' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                        <img src='/閱讀策略/b1.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />

                        <div className='w-full bg-[#E3F2FE] flex flex-col justify-start p-[32px] items-center'>
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>
                                除了小寵物外，你會不會也想知道其他動物是怎麼散熱的呢？如果想知道大象的散熱方法，應該點擊哪一個超連結？
                                <br />
                                <br />

                                <div className='flex flex-col gap-2 w-full text-left gap-[16px]'>
                                    <div className='flex flex-row'>
                                        A.	超連結一︰<div className='text-blue-500 underline cursor-pointer'>大象<mark>降温方法</mark>大公開</div>
                                    </div>

                                    <div className='flex flex-row'>
                                        B.	超連結二︰<div className='text-blue-500 underline cursor-pointer'>大象每天<mark>最愛吃甚麼</mark></div>
                                    </div>

                                    <div className='flex flex-row'>
                                        C.	超連結三︰<div className='text-blue-500 underline cursor-pointer'>大象共有多少個<mark>品種</mark></div>
                                    </div>

                                    <div className='flex flex-row'>
                                        D.	超連結四︰<div className='text-blue-500 underline cursor-pointer'>大象的<mark>生活習慣</mark></div>
                                    </div>
                                </div>
                                <br />
                                黃色標示的詞語哪個與散熱有關呢？把想找的目標「散熱方法」跟各選項的關鍵字進行「聯想」：散熱就是讓身體熱氣散走，讓身體降温，跟選項A對應；其他選項 (吃甚麼、品種、生活習慣) 都跟「散熱方法」無關。
                                <br />
                                <br />

                            </div>
                            <br />
                            <img src='/閱讀策略/2-02.png' style={{ maxWidth: 'min(100%, 1000px)', objectFit: 'contain' }} alt='閱讀策略' />



                        </div>
                        <img src='/閱讀策略/b2.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                        <div className='w-full bg-[#DDFBF6] flex flex-col justify-start p-[32px] items-center'>
                            <br />
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>

                               同學們，學會了「推論超連結是否有用」策略後，現在輪到你們試一試啦！
                                <br />
                                <br />
                                <br />

                            </div>



                            <div className='w-full mt-[16px] flex flex-col items-start gap-[16px] max-w-[800px] bg-[#E3F2FE] p-[16px]'>
                                <div className='w-full'>
                                    1.	<u>小美</u>明天會到<u>香港迪士尼樂園</u>遊玩，她想先找出「小小世界」在哪裏。以下哪一個超連結最有用？
                                </div>
                                {[
                                    { text: "A. 超連結一︰餐飲推薦 ", id: 'A' },
                                    { text: "B. 超連結二︰樂園表演時間表 ", id: 'B' },
                                    { text: "C. 超連結三︰熱門角色介紹 ", id: 'C' },
                                    { text: "D. 超連結四︰樂園地圖 ", id: 'D' },


                                ].map((option, optionIndex) => (
                                    <div key={optionIndex} className='w-full flex flex-col gap-[4px]'>
                                        <div className='flex flex-row gap-[8px] items-center'>
                                            <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                <button onClick={() => {
                                                    let ans = []
                                                    if (ans.includes(option.id)) {
                                                        ans = ans.filter(a => a !== option.id)
                                                    } else {
                                                        ans.push(option.id)
                                                    }
                                                    setQuestion1SelectedAnswers(ans)
                                                }}
                                                    className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${question1SelectedAnswers.includes(option.id) ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                ></button>
                                            </div>
                                            <div className='underline text-[#2089dd]' dangerouslySetInnerHTML={{ __html: option.text }}></div>
                                        </div>
                                        <div style={{ borderBottom: '4px dotted #2089dd' }}></div>
                                    </div>
                                ))}
                                <div className='w-full flex flex-row justify-end items-center'>
                                    <div className='cursor-pointer hover:opacity-[0.8] text-[white] font-bold text-[18px] bg-[rgb(245,140,0)] px-[12px] py-[4px] rounded-[10px]' onClick={() => {
                                        if (question1SelectedAnswers.length === 1 && question1SelectedAnswers.includes('D')) {
                                            setQuestion1PopupVisible(true)
                                        } else {
                                            setShowWrongAnswerPopup1(true)
                                        }
                                    }}>
                                        提交
                                    </div>
                                </div>

                            </div>


                        </div>


                        {/*question2*/}
                        <div className='w-full bg-[#DDFBF6] flex flex-col justify-start p-[32px] items-center'>
                        
                            <div className='w-full mt-[16px] flex flex-col items-start gap-[16px] max-w-[800px] bg-[#D0E9FF] p-[16px]'>
                                <div className='w-full'>
                                    2.	<u>小文</u>讀完網頁後，想觀賞文中提到「2016年由動畫大師繪製、在電影院放映並獲得全球好評的皮影動畫片」。以下四個超連結，點選哪一個最有用？
                                 </div>

                                {[
                                    { text: "A.	超連結一︰漢朝漢武帝與李夫人的愛情故事 ", id: 'A' },
                                    { text: "B. 超連結二︰傳統皮偶的雕刻與上色手工藝", id: 'B' },
                                    { text: "C. 超連結三︰首部皮影動畫電影線上看", id: 'C' },
                                    { text: "D. 超連結四︰如何利用三枝竹竿操控皮偶動作", id: 'D' },
                                ].map((option, optionIndex) => (
                                    <div key={optionIndex} className='w-full flex flex-col gap-[4px]'>
                                        <div className='flex flex-row gap-[8px] items-center'>
                                            <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                <button onClick={() => {
                                                    let ans = []
                                                    if (ans.includes(option.id)) {
                                                        ans = ans.filter(a => a !== option.id)
                                                    } else {
                                                        ans.push(option.id)
                                                    }
                                                    setQuestion2SelectedAnswers(ans)
                                                }}
                                                    className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${question2SelectedAnswers.includes(option.id) ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                ></button>
                                            </div>
                                            <div className='underline text-[#2089dd]' dangerouslySetInnerHTML={{ __html: option.text }}></div>
                                        </div>
                                        <div style={{ borderBottom: '4px dotted #2089dd' }}></div>
                                    </div>
                                ))}
                                <div className='w-full flex flex-row justify-end items-center'>
                                    <div className='cursor-pointer hover:opacity-[0.8] text-[white] font-bold text-[18px] bg-[rgb(245,140,0)] px-[12px] py-[4px] rounded-[10px]' onClick={() => {
            
                                         if (question2SelectedAnswers.length === 1 && question2SelectedAnswers.includes('C')) {
                                            setQuestion2PopupVisible(true)
                                        } else {
                                            setShowWrongAnswerPopup2(true)
                                        }
                                    }}>
                                        提交
                                    </div>
                                </div>

                            </div>


                        </div>
                        <br />
                        {/*return button*/}
                        <button onClick={props.onClose} className='mt-4 px-4 py-2 bg-blue-500 text-white rounded m-[32px]'>返回</button>
                    </div>
                    {/*end of web content*/}
                </div>
                {/*end of webpages*/}
            </div>

                         

             {question1PopupVisible && (
                <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-80'>
                    <div className='bg-white p-4 rounded max-w-[90%] max-h-[90%] overflow-auto flex flex-col items-center'>
                        <img src="/閱讀策略/icon.png" alt="" className='' style={{ objectFit: 'contain' }} />
                        {/* <div className='w-full'>答案：保持暖和</div> */}
                        <div className='w-full max-w-[600px] text-center'>
                            答對了，你真棒！
                        </div>
                        <br />
                        <div className='w-full max-w-[70%] text-align'>
                            小美想知道「小小世界」在哪裏，最需要的是能幫她找位置的資料。選項 D「樂園地圖」可以告訴她設施在哪個位置，最有用。其他選項(餐飲推薦、表演時間表和熱門角色介紹)，和找「小小世界」的位置沒有關係。
                        </div>
                        <br />
                        <button onClick={() => setQuestion1PopupVisible(false)} className='mt-4 px-[24px] py-2 text-[#0000FF] rounded-full' style={{ border: '2px solid #0000FF' }}>返回</button>
                    </div>
                </div>
            )}
             {question2PopupVisible && (
                <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-80'>
                    <div className='bg-white p-4 rounded max-w-[90%] max-h-[90%] min-w-[500px] overflow-auto flex flex-col items-center'>
                        <img src="/閱讀策略/icon.png" alt="" className='' style={{ objectFit: 'contain' }} />
                        {/* <div className='w-full'>答案：B</div> */}
                        <div className='w-full max-w-[600px] text-center'>
                            答對了，你真棒！
                        </div>
                        <br />
                        <div className='w-full max-w-[70%] text-align'>
                            題目要找「觀賞2016年的皮影動畫片」，選項 C 提到的「首部皮影動畫電影線上看（觀賞影片）」最符合需求。其他選項（愛情故事、雕刻手工藝、操控皮偶動作）均與觀賞該動畫片無關。
                        </div>
                        <br />
                        <button onClick={() => setQuestion2PopupVisible(false)} className='mt-4 px-[24px] py-2 text-[#0000FF] rounded-full' style={{ border: '2px solid #0000FF' }}>返回</button>
                    </div>
                </div>
            )}
            {showWrongAnswerPopup1 && (
                <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-80'>
                    <div className='bg-white p-4 rounded max-w-[90%] max-h-[90%] min-w-[500px] overflow-auto flex flex-col items-center'>
                        <img src="/閱讀策略/icon.png" alt="" className='' style={{ objectFit: 'contain' }} />
                        <div className='w-full max-w-[600px] text-center'>
                            答錯了，請再嘗試！<br /><br />提示：
                        </div>
                        <div className='w-full text-align max-w-[70%]'>
                            <br />{question1SelectedAnswers.includes('A')
                            ?'「餐飲推薦」是介紹餐廳和食物的，不能幫助小美找「小小世界」的位置。找一找與地點有關的超連結。'
                            : question1SelectedAnswers.includes('B')
                            ? '「樂園表演時間表」是查看表演在甚麼時間舉行的，不能告訴小美「小小世界」在哪裏。找一找與地點有關的超連結。'
                            : question1SelectedAnswers.includes('C')
                            ? '「熱門角色介紹」是介紹迪士尼人物的，和找遊樂設施的位置沒有關係。找一找與地點有關的超連結。'
                            : ''
                            }
                        </div><br />

                        <button onClick={() => setShowWrongAnswerPopup1(false)} className='mt-4 px-[24px] py-2 text-[#0000FF] rounded-full' style={{ border: '2px solid #0000FF' }}>返回</button>
                    </div>
                </div>
            )}
            {showWrongAnswerPopup2 && (
                <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-80'>
                    <div className='bg-white p-4 rounded max-w-[90%] max-h-[90%] min-w-[500px] overflow-auto flex flex-col items-center'>
                        <img src="/閱讀策略/icon.png" alt="" className='' style={{ objectFit: 'contain' }} />
                        <div className='w-full max-w-[600px] text-center'>
                            答錯了，請再嘗試！<br /><br />提示：
                        </div>
                        <div className='w-full text-align max-w-[70%]'>
                            <br />{
                                question2SelectedAnswers.includes('A')
                                ? '這個連結介紹歷史故事，和觀賞皮影動畫片沒有關係。找一找與動畫電影有關的連結。'
                                : question2SelectedAnswers.includes('B')
                                ? '這個連結介紹皮偶的製作方法，不是用來觀看動畫電影的。找一找與動畫電影有關的連結。'
                                : question2SelectedAnswers.includes('D')
                                ? '這個連結介紹操控皮偶的方法，和觀賞皮影動畫片沒有關係。找一找與動畫電影有關的連結。'
                                : ''
                            }
                        </div><br />
                        <button onClick={() => setShowWrongAnswerPopup2(false)} className='mt-4 px-[24px] py-2 text-[#0000FF] rounded-full' style={{ border: '2px solid #0000FF' }}>返回</button>
                    </div>
                </div>
            )}




        </div>
    )
}